import {
  QUEUE_ICON_COLORS,
  QUEUE_ICON_MEANINGS,
  queueIconColor,
  queueIconMeaningForNotification,
  type QueueIconColor,
  type QueueIconMeaning,
} from '@tenfour/contracts'
import s from './QueueIcon.module.css'

export {
  QUEUE_ICON_COLORS,
  QUEUE_ICON_MEANINGS,
  queueIconColor,
  queueIconMeaningForNotification,
}
export type { QueueIconColor, QueueIconMeaning }

interface QueueIconProps {
  meaning: QueueIconMeaning
  color: QueueIconColor
  className?: string
}

function iconPath(meaning: QueueIconMeaning, color: QueueIconColor, size: 64 | 128) {
  return `/icons/queue/queue-${color}-${meaning}-${size}.webp`
}

/**
 * Decorative Ten Four clay icon. The 64px source is sufficient for dense
 * feed slots; srcSet supplies the 128px copy for retina and larger identity
 * placements without shipping the 1254px Design master.
 */
export function QueueIcon({ meaning, color, className }: QueueIconProps) {
  return (
    <img
      src={iconPath(meaning, color, 64)}
      srcSet={`${iconPath(meaning, color, 64)} 1x, ${iconPath(meaning, color, 128)} 2x`}
      width={64}
      height={64}
      alt=""
      className={`${s.icon} ${className ?? ''}`.trim()}
      decoding="async"
      aria-hidden="true"
      draggable={false}
    />
  )
}
